import { memo, ReactComponentElement, ReactNode } from 'react';
import cls from 'classnames';

import FancyPopup, { FancyPopupOption } from '../FancyPopup/FancyPopup';

import styles from './FancyTooltip.module.css';

interface TooltipProps extends Omit<FancyPopupOption, 'action'> {
  children: ReactComponentElement<Any>;
  content: ReactNode;
  action?: FancyPopupOption['action'];
  className?: string;
}

function FancyTooltip(props: TooltipProps) {
  const { action = 'hover', children, content, className, ...rest } = props;

  if (!content) {
    return children;
  }

  return (
    <FancyPopup
      action={action}
      trigger={children}
      body={content}
      className={cls(styles.content, className)}
      {...rest}
    />
  );
}

export default memo(FancyTooltip);
